export default "__VITE_ASSET__0mA$ZSsB__"